import { useState } from 'react';
import { Wrapper, Track, Slide, ArrowButton, Dots, Dot } from './styles';

const SCREENSHOTS = [
    '/assets/AppStore-1.png',
    '/assets/AppStore-2.png',
    '/assets/AppStore-3.png',
    '/assets/AppStore-4.png',
    '/assets/AppStore-5.png',
];

const Carousel = () => {
    const [index, setIndex] = useState(0);

    return (
        <Wrapper>
            <ArrowButton
                onClick={() => setIndex(i => Math.max(0, i - 1))}
                disabled={index === 0}
                aria-label="Previous screenshot"
            >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M15 18l-6-6 6-6" />
                </svg>
            </ArrowButton>
            <Track>
                <Slide style={{ transform: `translateX(-${index * 100}%)` }}>
                    {SCREENSHOTS.map((src, i) => (
                        <img key={i} src={src} alt={`SmarterToDo screenshot ${i + 1}`} />
                    ))}
                </Slide>
            </Track>
            <ArrowButton
                onClick={() => setIndex(i => Math.min(SCREENSHOTS.length - 1, i + 1))}
                disabled={index === SCREENSHOTS.length - 1}
                aria-label="Next screenshot"
            >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M9 18l6-6-6-6" />
                </svg>
            </ArrowButton>
            <Dots>
                {SCREENSHOTS.map((_, i) => (
                    <Dot key={i} $active={i === index} onClick={() => setIndex(i)} />
                ))}
            </Dots>
        </Wrapper>
    );
};

export default Carousel;
